module.exports = __webpack_public_path__ + "static/thumbnail-b91ebdcf01db26c1777213723dd4e5ce.jpg";